import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

export const HeadoxTheme = definePreset(Aura, {
  primitive: {
    borderRadius: {
      lg: '10px',
    },
  },
  semantic: {
    primary: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#FF833F',
      600: '#E96924',
      700: '#ea580c',
      800: '#c2410c',
      900: '#9a3412',
      950: '#7c2d12',
    },

    formField: {
      paddingX: '1rem',
      paddingY: '0.875rem',
      borderRadius: '{border.radius.lg}',
      lg: {
        fontSize: '1rem',
        paddingX: '1.5rem',
        paddingY: '0.95rem',
      },
    },

    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f9f9f9',
          100: '#f6f6f6',
          200: '#e3e3e3',
          300: '#d1d5db',
          400: '#a1a1a1',
          500: '#919191',
          600: '#6b7280',
          700: '#4b5563',
          800: '#333333',
          900: '#1f2937',
          950: '#0f172a',
        },
        text: {
          color: '{surface.500}',
        },
        content: {},
        formField: {
          filledBackground: '{surface.100}',
          filledHoverBackground: '{surface.100}',
          filledFocusBackground: '{surface.100}',
          borderColor: '{surface.0}',
          hoverBorderColor: '{surface.200}',
          focusBorderColor: '{surface.200}',
          shadow: 'none',
          invalidPlaceholderColor: '{red.400}',
        },
      },
    },
  },

  components: {
    togglebutton: {
      root: {
        fontWeight: '400',
        padding: '0.45rem',
        borderRadius: '{border.radius.lg}',
      },
      content: {
        checkedShadow: 'none',
      },
      colorScheme: {
        light: {
          root: {
            background: 'transparent',
            checkedBackground: 'transparent',
            hoverBackground: 'transparent',
            borderColor: '{surface.500}',
            color: '{text.hover.color}',
            checkedColor: '{text.hover.color}',
            checkedBorderColor: '{primary.500}',
          },
          content: {
            checkedBackground: 'transparent',
          },
        },
      },
    },
    card: {
      root: {
        shadow: 'none',
        borderRadius: '{border.radius.lg}',
      },
      body: {
        padding: '1rem',
      },
    },
    toolbar: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        padding: '0rem',
      },
    },
    button: {
      root: {
        iconOnlyWidth: '3rem',
        sm: {
          fontSize: '1rem',
          iconOnlyWidth: '2.5rem',
        },
        lg: {
          fontSize: '1rem',
          iconOnlyWidth: '3.5rem',
        },
      },
      colorScheme: {
        light: {
          root: {
            primary: {
              background:
                'linear-gradient(180deg, {primary.500} 0%, {primary.600} 100%)',
              hoverBackground:
                'linear-gradient(180deg, {primary.600} 0%, {primary.700} 100%)',
              activeBackground:
                'linear-gradient(180deg, {primary.700} 0%, {primary.800} 100%)',
            },
            secondary: {
              background: '{surface.100}',
              hoverBackground: '{surface.200}',
              activeBackground: '{surface.300}',
              borderColor: '{surface.100}',
              hoverBorderColor: '{surface.100}',
              activeBorderColor: '{surface.100}',
              color: '{primary.500}',
              hoverColor: '{primary.500}',
              activeColor: '{primary.500}',
            },
            warn: {
              background: '#FFE273',
              hoverBackground: '#F5D65A',
              activeBackground: '#EBCB48',
              borderColor: '#FFE273',
              hoverBorderColor: '#F5D65A',
              activeBorderColor: '#EBCB48',
              color: '{surface.800}',
              hoverColor: '{surface.800}',
              activeColor: '{surface.800}',
            },
            contrast: {
              background: '{surface.0}',
              hoverBackground: '{surface.0}',
              activeBackground: '{surface.0}',
              borderColor: '{surface.0}',
              hoverBorderColor: '{surface.200}',
              activeBorderColor: '{surface.200}',
              color: '{surface.800}',
              hoverColor: '{surface.800}',
              activeColor: '{surface.800}',
            },
          },
        },
      },
    },
    dataview: {
      header: {
        background: 'transparent',
        borderWidth: '0px',
      },
      content: {
        background: 'transparent',
      },
      footer: {
        padding: '1rem 0',
        background: 'transparent',
        borderWidth: '0px',
      },
    },

    avatar: {
      lg: {
        fontSize: '1rem',
      },
      xl: {
        fontSize: '1.5rem',
        width: '7rem',
        height: '7rem',
      },
    },

    progressspinner: {
      colorScheme: {
        light: {
          root: {
            colorOne: '{primary.500}',
            colorTwo: '{primary.600}',
            colorThree: '{primary.500}',
            colorFour: '{primary.600}',
          },
        },
      },
    },

    fileupload: {
      root: {
        background: '{surface.100}',
        borderColor: '{surface.100}',
      },
      header: {
        padding: 'none',
      },
      content: {
        padding: 'none',
      },
      file: {
        padding: 'none',
      },
    },
  },
})
